// extracted by mini-css-extract-plugin
module.exports = {"emojiWrap":"Emoji_index_emojiWrap__2lYua","emoji":"Emoji_index_emoji__1LJ9G","insertImg":"Emoji_index_insertImg__zW9BG"};